import {HttpServices} from "../Helpers";

export const GetMSTeamsMeetingProviders = async ({user_uuid}) =>
  await HttpServices.get(
    `${process.env.REACT_APP_INTEGRATIONS_API}/integrations/teams/meeting-providers`,
    {
      params: {
        user_uuid,
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

export const GetMSExchangeMeetingProviders = async () =>
  await HttpServices.get(
    `${process.env.REACT_APP_INTEGRATIONS_API}/integrations/ms-exchange/meeting-providers`
  )
    .then((data) => data)
    .catch((error) => error.response);

export const MSTeamsScheduleInterview = async ({body, user_uuid}) =>
  await HttpServices.post(
    `${process.env.REACT_APP_INTEGRATIONS_API}/integrations/teams/schedule-meeting?user_uuid=${user_uuid}`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);

export const MSTeamsViewScheduleInterview = async ({
  user_uuid,
  meeting_uuid,
  is_upcoming,
  from_time,
  to_time,
  page,
  limit = 50,
}) =>
  await HttpServices.get(
    `${process.env.REACT_APP_INTEGRATIONS_API}/integrations/teams/get-meeting-data`,
    {
      params: {
        meeting_uuid,
        user_uuid,
        page,
        limit,
        is_upcoming,
        from_time,
        to_time,
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

export const MSTeamsDeleteEvent = async ({user_uuid, meeting_uuid}) =>
  await HttpServices.delete(
    `${process.env.REACT_APP_INTEGRATIONS_API}/integrations/teams/cancel-meeting`,
    {
      params: {
        user_uuid,
        meeting_uuid,
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);
